import properties from 'resources/constants/properties.json';

import ReactGA from 'react-ga4';

export const sendEvent = ({ category, action, label, params = {}, ...props }) => (_dispatch, getState) => {
  const isMobile = getState().globalState.isMobile
  if(properties.gaId && properties.gaId !== "disabled") {
    const event = {
      category: isMobile ? category + "_mobile" : category,
      action,
      label,
      ...props
    };
    ReactGA.event(event, params)
  }
}